import { useEffect, useState } from "react";
import { Link, Navigate, useLocation } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { http } from "@/lib/api";

export default function NotFound() {
  return (
    <>
      <Seo title="Page Not Found | SHADC Dispensary" description="The page you were looking for could not be found." path="/404/" noindex />
      <div className="container-x py-24 text-center" data-testid="not-found">
        <p className="eyebrow">404</p>
        <h1 className="mt-3 text-4xl font-bold text-white sm:text-5xl">We couldn&apos;t find that page</h1>
        <p className="mt-4 text-gray-400">It may have moved. Try the menu or head back home.</p>
        <div className="mt-8 flex justify-center gap-3"><Link to="/shop/" className="btn-gold">Shop the menu</Link><Link to="/" className="btn-ghost">Home</Link></div>
      </div>
    </>
  );
}

export function LegacyRedirect() {
  const { pathname } = useLocation();
  const [to, setTo] = useState(undefined);
  useEffect(() => {
    http.get("/redirects/resolve", { params: { path: pathname } }).then((r) => setTo(r.data.to || null)).catch(() => setTo(null));
  }, [pathname]);
  if (to === undefined) return <div className="container-x h-96" aria-busy="true" />;
  return to ? <Navigate to={to} replace /> : <NotFound />;
}
